import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../../../firebase';
import { collection, query, where, orderBy, getDocs } from 'firebase/firestore';
import './info.css';
import coming from '../../../main_assets/coming.png';

const Info = () => {
  const navigate = useNavigate();
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [pastEvents, setPastEvents] = useState([]);
  const [visibleCount, setVisibleCount] = useState(4);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        setLoading(true);
        const eventsRef = collection(db, 'events');
        
        // Fetch upcoming events (events with start date in the future)
        const upcomingQuery = query(
          eventsRef, 
          where('startDate', '>', new Date()),
          orderBy('startDate', 'asc')
        );
        
        // Fetch past events (events with start date in the past)
        const pastQuery = query(
          eventsRef, 
          where('startDate', '<', new Date()),
          orderBy('startDate', 'desc')
        );

        // Execute queries
        const upcomingSnapshot = await getDocs(upcomingQuery);
        const pastSnapshot = await getDocs(pastQuery);

        // Transform snapshots to arrays
        const upcomingEventsData = upcomingSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          startDate: doc.data().startDate?.toDate(), 
          endDate: doc.data().endDate?.toDate()
        }));

        const pastEventsData = pastSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          startDate: doc.data().startDate?.toDate(),
          endDate: doc.data().endDate?.toDate()
        }));

        setUpcomingEvents(upcomingEventsData);
        setPastEvents(pastEventsData);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching events:', err);
        setError('Failed to load events');
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  const handleRegisterClick = () => {
    navigate('/register'); 
  };

  const visiblePastEvents = pastEvents.slice(0, visibleCount);

  // Helper function to format date
  const formatDate = (date) => {
    if (!date) return 'Date Not Specified';
    return new Intl.DateTimeFormat('en-US', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    }).format(date);
  };

  if (loading) {
    return <div>Loading events...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="ulev__info section__padding" style={{ backgroundColor: "#E54141" }}>
      {/* Title and Events Container */}
      <div className="ulev__info-header">
        <h1 className="ulev__info-title" style={{ fontFamily: "Poppins-SemiBold", fontSize: "clamp(28px, 4vw, 37px)" }}>Up Coming Events</h1>
      </div>

      <div className="ulev__info-events-container">
        {[1, 2].map((_, index) => (
          <div key={index} className="ulev__info-event">
            {/* Event Image */}
            <div className="ulev__info-event-image" style={{
            }}>
              <img src={coming} alt="Event" />
            </div>
            {/* Event Details */}
            <div className="ulev__info-event-details">
              <h2 className="event-title" style={{ fontFamily: "Poppins-SemiBold" }}>
                Event Title and Name Event Title and Name
              </h2>
              <p className="event-description" style={{ fontFamily: "Poppins-Light" }}>
                Brief description about the event in here.
              </p>
              <p className="event-location" style={{ fontFamily: "Poppins-Light" }}>
                Buea, Cameroon | 10th November 2024
              </p>
            </div>
            {/* Action Buttons */}
            <div className="ulev__info-event-buttons">
              <button
                className="register-btn"
                style={{ fontFamily: "Poppins-Light" }}
                onClick={handleRegisterClick}
              >
                Register
              </button>
              <button className="sponsor-btn" style={{ fontFamily: "Poppins-Light" }}>
                Become A Sponsor
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Info;








// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { db } from '../../../firebase';
// import { collection, query, where, orderBy, getDocs, limit } from 'firebase/firestore';
// import './info.css';
// import coming from '../../../main_assets/coming.png';

// const Info = () => {
//   const navigate = useNavigate();
//   const [upcomingEvents, setUpcomingEvents] = useState([]);
//   const [pastEvents, setPastEvents] = useState([]);
//   const [visibleCount, setVisibleCount] = useState(4);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchEvents = async () => {
//       try {
//         setLoading(true);
//         const eventsRef = collection(db, 'events');
        
//         // Fetch upcoming events (events with start date in the future)
//         const upcomingQuery = query(
//           eventsRef, 
//           where('startDate', '>', new Date()),
//           orderBy('startDate', 'asc'),
//           limit(2) 
//         );
        
//         // Fetch past events (events with start date in the past)
//         const pastQuery = query(
//           eventsRef, 
//           where('startDate', '<', new Date()),
//           orderBy('startDate', 'desc')
//         );

//         // Execute queries
//         const upcomingSnapshot = await getDocs(upcomingQuery);
//         const pastSnapshot = await getDocs(pastQuery);

//         // Transform snapshots to arrays
//         const upcomingEventsData = upcomingSnapshot.docs.map(doc => ({
//           id: doc.id,
//           ...doc.data(),
//           startDate: doc.data().startDate?.toDate(), 
//           endDate: doc.data().endDate?.toDate()
//         }));

//         const pastEventsData = pastSnapshot.docs.map(doc => ({
//           id: doc.id,
//           ...doc.data(),
//           startDate: doc.data().startDate?.toDate(),
//           endDate: doc.data().endDate?.toDate()
//         }));

//         setUpcomingEvents(upcomingEventsData);
//         setPastEvents(pastEventsData);
//         setLoading(false);
//       } catch (err) {
//         console.error('Error fetching events:', err);
//         setError('Failed to load events');
//         setLoading(false);
//       }
//     };

//     fetchEvents();
//   }, []);

//   const handleRegisterClick = () => {
//     navigate('/register'); 
//   };

//   const visiblePastEvents = pastEvents.slice(0, visibleCount);

//   // Helper function to format date
//   const formatDate = (date) => {
//     if (!date) return 'Date Not Specified';
//     return new Intl.DateTimeFormat('en-US', {
//       day: 'numeric',
//       month: 'long',
//       year: 'numeric'
//     }).format(date);
//   };

//   if (loading) {
//     return <div>Loading events...</div>;
//   }

//   if (error) {
//     return <div>Error: {error}</div>;
//   }

//   return (
//     <div className="ulev__info section__padding" style={{ backgroundColor: "#CD3333" }}>
//       {/* Title and Events Container */}
//       <div className="ulev__info-header">
//         <h1 className="ulev__info-title" style={{ fontFamily: "Poppins-SemiBold" }}>
//           {upcomingEvents.length > 0 ? "Upcoming Events" : "No Upcoming Events"}
//         </h1>
//       </div>

//       <div className="ulev__info-events-container">
//         {upcomingEvents.length > 0 ? (
//           upcomingEvents.map((event) => (
//             <div key={event.id} className="ulev__info-event">
//               {/* Event Image */}
//               <div className="ulev__info-event-image">
//                 <img src={event.imageUrl || coming} alt={event.title || "Event"} />
//               </div>
//               {/* Event Details */}
//               <div className="ulev__info-event-details">
//                 <h2 className="event-title" style={{ fontFamily: "Poppins-SemiBold" }}>
//                   {event.title || "Untitled Event"}
//                 </h2>
//                 <p className="event-description" style={{ fontFamily: "Poppins-Light" }}>
//                   {event.description || "No description available"}
//                 </p>
//                 <p className="event-location" style={{ fontFamily: "Poppins-Light" }}>
//                   {event.location || "Location Not Specified"} | {formatDate(event.startDate)}
//                 </p>
//               </div>
//               {/* Action Buttons */}
//               <div className="ulev__info-event-buttons">
//                 <button
//                   className="register-btn"
//                   style={{ fontFamily: "Poppins-Light" }}
//                   onClick={handleRegisterClick}
//                 >
//                   Register
//                 </button>
//                 <button className="sponsor-btn" style={{ fontFamily: "Poppins-Light" }}>
//                   Become A Sponsor
//                 </button>
//               </div>
//             </div>
//           ))
//         ) : (
//           <div className="no-events">No upcoming events at the moment.</div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Info;
